<template>
  <div class="EditOverflowContainer">
    <div
      ref="listContainer"
      class="EditOverflowContainer-MaxHeightWrapper"
      :style="{ 'max-height': computedMaxHeight, visibility: visibility }"
    >
      <div
        class="gradient top"
        v-if="overflown"
        :style="{
          opacity: gradient_top_opacity,
          visibility: gradient_visibility
        }"
      ></div>
      <div
        class="gradient bottom"
        v-if="overflown"
        :style="{
          opacity: gradient_bottom_opacity,
          visibility: gradient_visibility
        }"
      ></div>
      <slot name="default"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "ListOverflowScroll",
  data() {
    return {
      overflown: false,
      gradient_top_opacity: 1.0,
      gradient_bottom_opacity: 1.0,
      visibility: "hidden",
      gradient_visibility: "hidden"
    };
  },
  props: {
    maxListHeight: {
      type: Number,
      default: 1200
    }
  },
  created() {
    setTimeout(this.checkOverflown, 0);
  },
  computed: {
    computedMaxHeight() {
      return this.maxListHeight + "px";
    }
  },
  methods: {
    checkOverflown() {
      this.gradient_visibility = "hidden";
      if (typeof this.$refs.listContainer === "undefined") {
        this.overflown = false;
        return;
      }
      let elem = this.$refs.listContainer;
      elem.removeEventListener("scroll", this.scroll);
      if (elem.scrollHeight > elem.clientHeight) {
        elem.addEventListener("scroll", this.scroll);
        this.gradient_bottom_opacity = 1.0;
        this.gradient_top_opacity = 1.0;
        setTimeout(() => {
          this.scroll(0);
        }, 0);
      }
      this.$refs.listContainer.scrollTo(0, 0);
      this.visibility = "visible";
    },
    scroll(event) {
      this.overflown = true;
      this.gradient_visibility = "visible";
      let elem = this.$refs.listContainer;
      let distance_from_bottom =
        elem.scrollHeight - (elem.clientHeight + elem.scrollTop);
      let bottom_multiplier =
        distance_from_bottom > 300 ? 1.0 : distance_from_bottom + 1 / 300.0;
      this.gradient_bottom_opacity = bottom_multiplier;
      let top_multiplier =
        elem.scrollTop > 300 ? 1.0 : elem.scrollTop + 1 / 300.0;
      this.gradient_top_opacity = top_multiplier;
    },
    scrollToTop() {
      this.$refs.listContainer.scrollTo(0, 0);
    }
  }
};
</script>

<style scoped>
.EditOverflowContainer {
  position: relative;
}

.EditOverflowContainer-MaxHeightWrapper {
  overflow: scroll;
}

.gradient {
  transition: opacity 0.5s ease;
  z-index: 100;
  position: absolute;
  pointer-events: none;
  height: 60px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  visibility: hidden;
}

.gradient.top {
  top: -3px;
  background: var(--component_common_editOverflowScroll_gradient_top_background);
}

.gradient.bottom {
  bottom: -3px;
  background: var(--component_common_editOverflowScroll_gradient_bottom_background);
}
</style>
